export default "__VITE_ASSET__CJV3VnWl__"